import type { ComponentType } from 'react'
import type { SlideId } from '@/tenant/TenantConfig'
import { OverallSlide } from './OverallSlide'
import { SalesFinanceSlide } from './SalesFinanceSlide'
import { SupportSatisfactionSlide } from './SupportSatisfactionSlide'
import { TeamsPerformanceSlide } from './TeamsPerformanceSlide'
import { MapSlide } from './MapSlide'
import { OrdersLiveSlide } from './OrdersLiveSlide'

export interface SlideEntry {
  id: SlideId
  titleKey: string
  Component: ComponentType
  defaultDurationSec: number
}

export const SLIDE_REGISTRY: Record<SlideId, SlideEntry> = {
  overall: {
    id: 'overall',
    titleKey: 'slides.overall',
    Component: OverallSlide,
    defaultDurationSec: 60,
  },
  sales: {
    id: 'sales',
    titleKey: 'slides.sales',
    Component: SalesFinanceSlide,
    defaultDurationSec: 60,
  },
  support: {
    id: 'support',
    titleKey: 'slides.support',
    Component: SupportSatisfactionSlide,
    defaultDurationSec: 45,
  },
  teams: {
    id: 'teams',
    titleKey: 'slides.teams',
    Component: TeamsPerformanceSlide,
    defaultDurationSec: 45,
  },
  map: {
    id: 'map',
    titleKey: 'slides.map',
    Component: MapSlide,
    defaultDurationSec: 45,
  },
  ordersLive: {
    id: 'ordersLive',
    titleKey: 'slides.ordersLive',
    Component: OrdersLiveSlide,
    defaultDurationSec: 45,
  },
}
